import { useAuth } from "../../contexts/AuthContext"

const ProfileModal = () => {
  const { currentUser } = useAuth()

  const titles = [
    ['Courriel', JSON.stringify(currentUser.user?.email, null, 2) ?? 'nomail@mail.com'],
    ['Pseudo', currentUser.user?.displayName ? JSON.stringify(currentUser.user?.displayName, null, 2) ?? 'John Doe' : 'John Doe'],
    ['Anniversaire', JSON.stringify(currentUser.user?.birthday, null, 2) ?? '01/01/1970'],
    ['Adresse', JSON.stringify(currentUser.user?.address, null, 2) ?? 'Elsewhere'],
  ]
  const titlesArray = titles.map(title =>
    <div key={title[0]} className="flex justify-start flex-row sm:gap-20 md:gap-16 lg:gap-10 xl:gap-0">
      <span className="font-bold sm:w-1/6">{title[0]}&nbsp;:&nbsp;</span>
      <span>{title[1].replaceAll('"', '')}</span>
    </div>
  )

  return (
    <div className="px-3 flex flex-col gap-2">
      {titlesArray}
    </div>
  )
}

export default ProfileModal
